import { FETCH_API_BASE_URL, FETCH_API_PAGES_URL } from './constants'
import { filterPropName } from '../helper/object'

const filterEntryProps = entry => filterPropName(entry, [
	'published',
	'path',
	'menu',
	'order',
	'title',
	'subtitle',
	'content',
])

export const fetchPages = (fetch, base_url) => async () => {
	return fetch(base_url + FETCH_API_PAGES_URL)
		.then(res => res.json())
		.then(res => res.entries)
		.then(res => res.map(filterEntryProps))
}

export default fetchPages(fetch, FETCH_API_BASE_URL)



// WEBPACK FOOTER //
// ./src/fetchAPI/fetchPages.js